import { render, staticRenderFns } from "./ProdutosTabela.vue?vue&type=template&id=4696aa13"
import script from "./ProdutosTabela.vue?vue&type=script&lang=js"
export * from "./ProdutosTabela.vue?vue&type=script&lang=js"
import style0 from "./ProdutosTabela.vue?vue&type=style&index=0&id=4696aa13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports